/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { init, browserTracingIntegration, httpClientIntegration, replayIntegration, consoleLoggingIntegration, dedupeIntegration, eventFiltersIntegration } from "@sentry/angular";
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { ENV_CONFIG_ENV_TYPES } from './app/environment.config';

if (environment.environment === ENV_CONFIG_ENV_TYPES.PROD) {
  init({
    dsn: "https://7c1b5e57781573f445c6c6d098547e0a@sentry.mindplay.com/2",
    beforeSendLog(event) {
      const ignoredErrors = [
        'FedCM',
      ]

      if (ignoredErrors.some(ig => event.message.includes(ig))) {
        return null;
      }
      return event;
    },
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    release: environment.version,

    integrations: [
      browserTracingIntegration(),
      httpClientIntegration(),
      replayIntegration({
        // Additional SDK configuration goes in here, for example:
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: false,
      }),
      // send console.log, console.warn, and console.error calls as logs to Sentry
      consoleLoggingIntegration({ levels: ["error"] }),

      eventFiltersIntegration(),     // applies default filters for known useless errors
      dedupeIntegration(),           // avoids sending the same error twice
    ],

    enableLogs: true,
    tracesSampleRate: 1.0,
    tracePropagationTargets: [],

    // Session Replay
    replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
